/**
 * Created by tomers on 5/28/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userEditPermissionGroupBubbleView.tmpl");

    var UserEditPermissionGroupBubbleView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserEditPermissionGroupBubbleView = Marionette.ItemView.extend({
            template: template,
            initialize: function(options) {
                this.permissionGroups = options.permissionGroups;
            },
            customTemplateHelpers: function() {
                return {
                    permissionGroups: this.permissionGroups
                };
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserEditPermissionGroupBubbleView;

});